export default __webpack_public_path__ + "static/media/bcf.3034e9af.jpg";